module.exports = __webpack_public_path__ + "static/img/fzg-home-slogan.ca96269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/pc/fzg-home-slogan.png
// module id = 175
// module chunks = 0